import { useEffect } from 'react';
import { useCustomQuery } from './apollo/ApolloCustomHooks';
import { IAppSetting } from '../interfaces/AppSetting';
import { EnumsValues } from '../enums/EnumsValues';
import { Query } from '../services/graphql/query';

export function useAppPageTitle(): string | undefined {
  const { data, error } = useCustomQuery<{ getAppSettingByKey: IAppSetting }>(
    Query.getAppSettingByKey,
    { variables: { input: { key: EnumsValues.SettingNames.PageTitle } } },
  );

  useEffect(() => {
    if (error) console.error('App.pageTitle', error);
  }, [error]);

  // Leave the existing document title intact until configuration is available.
  if (!data) return undefined;
  return (
    data.getAppSettingByKey?.setting_value || EnumsValues.DefaultValues.Title
  );
}
